import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "day-title-section" }
const _hoisted_2 = { class: "container maxWidth-sm" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px"} }, null, -1)
const _hoisted_4 = { class: "title-container" }
const _hoisted_5 = { class: "title-text" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-left hr-magazine-thick hr-magazine-short" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "container maxWidth-sm text-center"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "tick-icon glyphicon glyphicon-ok" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "read-toolbar-complete-button-text" }, "Complete Develop Day", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

import { debug as d } from "debug";
import { v4 as uuid } from "uuid";
import moment from "dayjs";
import axios from "axios";
import { computed, onBeforeMount, ref } from "vue";
import {
  CompleteActivityActionApiModel,
  CompleteSelfReviewActionApiModel,
  CompleteStepActionApiModel,
  DevelopUserActionApiModel,
  DevelopUserActionKind,
  ProfileApiModel,
  ReadPageActionApiModel,
} from "../../api-models";
import { csContext } from "../../services/cs-context";
import delay from "../../services/utilities/delay";
import { DevelopPlan } from "../../services/cms/develop-plan";
import {
  getDayNumber,
  getStepRoleFromDayNumber,
} from "../../components/develop/develop-plan-models";
import SwipeNavigationInfo from "../../components/swipe-navigation-info";
import CmsImg from "../../components/cms/cms-img.vue";
import CmsBody from "../../components/cms/cms-body.vue";
import cms from "../../services/cms/cms";
import {
  CmsDevelopPage,
  CmsDocument,
  isMandatoryActivity,
  sliceToActivityId,
} from "../../services/cms/cms-type-definitions";

const headerImage = null;

const titleLayout = "";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-develop-step-page',
  props: {
    doc: {},
    context: {}
  },
  setup(__props: any) {

const debug = d("cs.CmsDevelopStepPage");

const props = __props;
const doc = ref<CmsDevelopPage>(props.doc as CmsDevelopPage);

const associatedDevelopPlan = ref<DevelopPlan | null>(null);
const currentProgress = ref(csContext.userProfile.developProgress?.currentStrengthProgress);
const hasClickedComplete = ref(false);
const isLoaded = ref(false);

const isPlanStep = computed(() => {
  // See if the day_or_page_type is a number stored as a string
  return !!doc.value && !Number.isNaN(+doc.value?.data.day_or_page_type);
});

const title = computed(() => {
  return cms.asText(doc.value?.data?.title);
});

const titleHtml = computed(() => {
  return cms.asHtml(doc.value?.data?.title);
});

const subtitle = computed(() => {
  return cms.asText(doc.value?.data?.subtitle);
});

const readEndActivityId = computed(() => {
  return `${doc.value.id}.read-end`;
});

const completedActivityIds = computed(() => {
  return currentProgress.value?.completedActivityIds ?? [];
});

const isReadEndActivityComplete = computed(() => {
  return completedActivityIds.value.includes(readEndActivityId.value);
});

const mandatoryActivityIds = computed(() => {
  return doc.value.data.body
    .filter(isMandatoryActivity)
    .map((slice) => sliceToActivityId(slice, doc.value.id));
  // .concat([readEndActivityId.value]);
});

const allActivitiesComplete = computed(() => {
  return !mandatoryActivityIds.value.find(
    (id) => !currentProgress.value?.completedActivityIds.includes(id),
  );
});

const canCompleteDay = computed(() => {
  if (!currentProgress.value || !isPlanStep.value) {
    return false;
  }

  const dayNumber = getDayNumber(doc.value?.data.day_or_page_type);

  return (
    (typeof currentProgress.value.lastCompletedDayIndex === "number" &&
      currentProgress.value.lastCompletedDayIndex === dayNumber - 1) ||
    (typeof currentProgress.value.lastCompletedDayIndex !== "number" && dayNumber === 1)
  );
});

function back() {
  SwipeNavigationInfo.temporarilyDisable();
  window.history.back();
}

async function refreshCurrentProgress() {
  const profileResponse = await axios.get<ProfileApiModel>("/api/profile");
  currentProgress.value = profileResponse.data.developProgress?.currentStrengthProgress;
}

function getCommonActionProperties(actionKind: DevelopUserActionKind): any {
  return {
    id: uuid(),
    dateTimeOffset: moment().format(),
    cmsPageId: doc.value.id,
    strengthItemId: doc.value.data.strength_item_id,
    cmsPlanId: associatedDevelopPlan.value?.cmsPlanId,
    stepRole: getStepRoleFromDayNumber(doc.value.data.day_or_page_type),
    leaderTypeId: null,
    actionKind,
  };
}

async function saveActions(actions: DevelopUserActionApiModel[]): Promise<void> {
  await axios.patch("/api/developuseraction", actions);
}

async function saveAction(action: DevelopUserActionApiModel): Promise<void> {
  await saveActions([action]);
}

onBeforeMount(async () => {
  if (isPlanStep.value) {
    await refreshCurrentProgress();
    if (
      !currentProgress.value ||
      currentProgress.value.strengthItemId !== doc.value.data.strength_item_id
    ) {
      window.location.href = "/develop";
      return;
    }
    const plans = await cms.getDevelopPlans();
    const plan = plans.find((p) => p.strengthItemId === doc.value.data.strength_item_id);
    associatedDevelopPlan.value = plan as DevelopPlan;
    const readPageAction = {
      ...getCommonActionProperties("ReadPage"),
    } as ReadPageActionApiModel;
    await saveAction(readPageAction);
  }
  isLoaded.value = true;
});

const completeButton = ref();

async function completeDay() {
  if ((isPlanStep.value && !canCompleteDay.value) || hasClickedComplete.value) {
    return;
  }

  (completeButton.value as HTMLElement).classList.add("completed");
  const delayPromise = delay(3000);
  hasClickedComplete.value = true;
  const completeStepAction = {
    ...getCommonActionProperties("CompleteStep"),
  } as CompleteStepActionApiModel;
  await saveAction(completeStepAction);
  await delayPromise;
  window.location.href = "/develop";
}

async function handleActivityCompleted(activityId: string) {
  debug("handleActivityCompleted", activityId);
  if (!isPlanStep.value || currentProgress.value?.completedActivityIds.includes(activityId)) {
    return;
  }

  const completeActivityAction = {
    ...getCommonActionProperties("CompleteActivity"),
    activityId,
  } as CompleteActivityActionApiModel;
  await saveAction(completeActivityAction);
  await refreshCurrentProgress();
}

async function handleSelfReviewCompleted(activityId: string, answers: number[]) {
  debug("handleSelfReviewCompleted", activityId, answers);
  if (!isPlanStep.value || currentProgress.value?.completedActivityIds.includes(activityId)) {
    return;
  }

  const completeSelfReviewAction = {
    ...getCommonActionProperties("CompleteSelfReview"),
    activityId,
    answers,
  } as CompleteSelfReviewActionApiModel;
  const completeActivityAction = {
    ...getCommonActionProperties("CompleteActivity"),
    activityId,
  } as CompleteActivityActionApiModel;
  await saveActions([completeSelfReviewAction, completeActivityAction]);
  await refreshCurrentProgress();
}

return (_ctx: any,_cache: any) => {
  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["cms-develop-step-page", titleLayout])
      }, [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
              class: "btn btn-primary-back hidden-print back-button",
              onClick: back,
              type: "button"
            }, " Back "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", { innerHTML: titleHtml.value }, null, 8, _hoisted_6),
                _hoisted_7,
                (subtitle.value)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_8, _toDisplayString(subtitle.value), 1))
                  : _createCommentVNode("", true),
                _hoisted_9
              ]),
              headerImage
                ? (_openBlock(), _createBlock(CmsImg, {
                    key: 0,
                    class: "title-image",
                    src: headerImage
                  }))
                : _createCommentVNode("", true)
            ]),
            _hoisted_10
          ])
        ]),
        _createVNode(CmsBody, {
          cmsPage: doc.value,
          context: _ctx.context,
          completedActivityIds: completedActivityIds.value,
          onActivityCompleted: handleActivityCompleted,
          onSelfReviewCompleted: handleSelfReviewCompleted
        }, null, 8, ["cmsPage", "context", "completedActivityIds"]),
        (canCompleteDay.value || hasClickedComplete.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (canCompleteDay.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    ref_key: "completeButton",
                    ref: completeButton,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (completeDay())),
                    class: "read-toolbar-complete-button btn btn-primary btn-lg",
                    disabled: !allActivitiesComplete.value && !hasClickedComplete.value,
                    type: "button"
                  }, _hoisted_15, 8, _hoisted_12))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})